import { useDispatch } from 'react-redux';
import { disableListLoading, enableListLoading } from '../../store/listLoading/actions';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { globalErrorResponse } from '../../store/notifications/actions';
import { shopPrefix } from '../../config';
import { http } from '../axios';

export function useDeleteCart() {
    const dispatch = useDispatch();

    return () => {
        dispatch(enableListLoading());

        return http
            .delete(`${shopPrefix}/v1/shoppingcart/products`)
            .then(() => {
                invalidateCartSummaryQuery().then();
                invalidateShoppingCartProducts().then();
                invalidateCartGroupedItems().then();
                invalidateCartAggregations().then();
            })
            .catch(error => {
                dispatch(globalErrorResponse(error));
            })
            .finally(() => {
                dispatch(disableListLoading());
            });
    };
}
